import { Modal } from '@axafr-btc-ds/modal';
import { IconComponent } from '@axafr-btc-ds/icons';
import { ProductModalProps } from './ProductModal.interface';
import { Typography } from '@axafr-btc-ds/typography';

export const ProductModal = ({ content, isOpen, onClose, renderIcon, title }: ProductModalProps): JSX.Element => {
    return (
        <Modal
            isContentReady={ true }
            isRounded={ true }
            isOpen={ isOpen }
            onClose={ onClose }
            title={ title }
            icon={ renderIcon as unknown as IconComponent }
            describedBy='description'
            closeButtonAriaLabel='Fermer la fênêtre'
        >
            <Typography variant='body2' id='description'>{ content }</Typography>
        </Modal>
    );
};
